import Vue from 'vue'
import { lowerCase } from 'lodash'

Vue.filter('sentenceCase', function (value) {
    if (!value) return ''
    value = value.toString()
    return value.charAt(0).toUpperCase() + lowerCase(value.slice(1))
})


// WEBPACK FOOTER //
// ./src/plugins/filters.js